<script setup lang="ts">
import { computed } from 'vue';
import CityStatus from '@/components/city/CityStatus.vue';
import ApplicationType from '@/components/city/ApplicationType.vue';

interface Props {
  cityApplicability?: any;
  cityStatus?: string;
  title?: string;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  'update:cityApplicability': [value: any];
  'update:cityStatus': [value: any];
}>();

const cityApplicabilityValue = computed({
  get() {
    return props.cityApplicability;
  },
  set(value) {
    emits('update:cityApplicability', value);
  }
});

const cityStatusValue = computed({
  get() {
    return props.cityStatus;
  },
  set(value) {
    emits('update:cityStatus', value);
  }
});
</script>

<template>
  <div>
    <div class="city-application">
      <div class="field grid">
        <div class="col-6 flex align-items-center">
          <div class="border-solid">
            <CityStatus v-model:status="cityStatusValue" :title="title" />
          </div>
        </div>
        <div class="col-6">
          <div class="border-solid">
            <ApplicationType v-model:applicability="cityApplicabilityValue" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.border-solid {
  padding: 0.65rem;
  border: 1px solid #ced4da;
  border-radius: 3px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
